// @flow
export const CHANGE_CURRENT_DASHBOARD_PAGE = 'hive/dashboard/CHANGE_CURRENT_DASHBOARD_PAGE';
export const GET_DASHBOARD_CUSTOMISATION = 'hive/dashboard/GET_DASHBOARD_CUSTOMISATION';
export const LOAD_DASHBOARD_PAGE = 'hive/dashboard/LOAD_DASHBOARD_PAGE';
export const RECEIVE_DASHBOARD_CUSTOMISATION = 'hive/dashboard/RECEIVE_DASHBOARD_CUSTOMISATION';
export const SHOW_DASHBOARD_DATA = 'hive/dashboard/SHOW_DASHBOARD_DATA';
export const DISPLAY_ALL_PRODUCTS = 'hive/dashboard/DISPLAY_ALL_PRODUCTS';
export const DASHBOARD_EDIT_ON = 'hive/dashboard/DASHBOARD_EDIT_ON';
export const CANCEL_DASHBOARD_EDIT = 'hive/dashboard/CANCEL_DASHBOARD_EDIT';
export const SAVE_DASHBOARD_EDIT = 'hive/dashboard/SAVE_DASHBOARD_EDIT';
export const SAVE_DASHBOARD_SUCCESS = 'hive/dashboard/SAVE_DASHBOARD_SUCCESS';
export const UPDATE_CELL_POSITION = 'hive/dashboard/UPDATE_CELL_POSITION';
export const DELETE_CELL = 'hive/dashboard/DELETE_CELL';
export const ADD_NEW_DASHBOARD_PAGE = 'hive/dashboard/ADD_NEW_DASHBOARD_PAGE';
export const DASHBOARD_ADD_PRODUCT_ON = 'hive/dashboard/DASHBOARD_ADD_PRODUCT_ON';
export const DASHBOARD_ADD_PRODUCT_OFF = 'hive/dashboard/DASHBOARD_ADD_PRODUCT_OFF';
export const DASHBOARD_ADD_PRODUCT = 'hive/dashboard/DASHBOARD_ADD_PRODUCT';
export const DASHBOARD_REMOVE_PRODUCTS = 'hive/dashboard/DASHBOARD_REMOVE_PRODUCTS';
export const DASHBOARD_ADD_NEXT_PRODUCT_POSITION = 'hive/dashboard/DASHBOARD_ADD_NEXT_PRODUCT_POSITION';
export const REDIRECT_TO_POSTINSTALL_GROUPS = 'hive/dashboard/REDIRECT_TO_POSTINSTALL_GROUPS';



// WEBPACK FOOTER //
// ./src/core/state/dashboard/constants.js